<template>
  <div>
    <div class="profile__prizes_won">
      <div class="col-12 profile_prizes_won_header">
        {{ getTranslations.home_profile_profile_edit_change_settings }}
      </div>
      <h1 class="profile_settings_header">
        {{ getTranslations.home_profile_profile_edit_settings }}
      </h1>
      <div class="profile_settings_action"
           style="cursor: pointer"
           @click.prevent="showAppropriateModal(0)">
        <span class="profile_settings_action_title">
          {{ getTranslations.home_profile_profile_edit_change_username }}
        </span>
      </div>
      <div class="profile_settings_action"
           style="cursor: pointer"
           v-if="(isEligibleForPinChange() && !hideChangePassword)"
           @click.prevent="showAppropriateModal(1)">
        <span class="profile_settings_action_title">
          {{ getTranslations.home_profile_profile_edit_change_pin }}
        </span>
      </div>
      <span v-if="!hideLangSelection">
      <h1 class="profile_settings_header"  >
        {{ getTranslations.home_profile_profile_edit_app_settings }}
      </h1>
      <div class="profile_settings_action action_onsite " >
        <span class="profile_settings_action_title" >
          {{ getTranslations.home_settings_language }}
        </span>
        <span class="profile_settings_action_title action_title_value">
          <a v-for="(value, key, index) in localesMappedWithIndices"
             @click.prevent="updateAndStoreNewLanguageAndLocale(key, value[0])"
             :class="settingsPageLocales[value[0]] && settingsPageLocales[value[0]].isActive ? 'selected' : ''"
             style="cursor: pointer"
             :key="index">
            {{ value[1] }}
          </a>
        </span>
      </div>
      </span>
      <h1 class="profile_settings_header">
        {{ getTranslations.home_profile_profile_edit_other_settings }}
      </h1>
      <div class="profile_settings_action"
           @click.prevent="userChangeStatus()"
           style="cursor: pointer">
        <span class="profile_settings_action_title">{{ userStatus }}</span>
      </div>
    </div>
    <component :is="modalForSettings" @close="storeModalForSettings(null)"></component>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';
import ChangeUsername from '@/components/home/modals/ChangeUsername';
import SetPin from '@/components/home/modals/ChangeLoginPin';
import Unsubscribe from '@/components/home/modals/Unsubscribe';
import UnsubscribeSms from '@/components/home/modals/UnsubscribeSms';
import ResubscribeRequestSettings from '@/components/home/modals/ResubscribeRequestSettings';
import ResubscribeQuestionViaSms from '@/components/home/modals/ResubscribeQuestionViaSms';
import modals from '../../../common/modals';

export default {
  name: 'profile-edit',
  mixins: [RegistrationFlowMixin],
  data() {
    return {
      userStatus: '',
      editProfilePage: 'editProfile',
    };
  },
  created() {
    this.getUserStatusMethod();
    this.setProfilePath(false);
  },
  updated() {
    this.getUserStatusMethod();
  },
  beforeDestroy() {
    this.setProfilePath(true);
  },
  methods: {
    ...mapMutations('common', [
      'setProfilePath',
      'setSoundsOnOrOff',
      'storeModalForSettings',
    ]),
    ...mapMutations('i18n', [
      'setLocale',
      'updateActiveLocale',
    ]),
    ...mapActions('i18n', [
      'getLocaleAndTranslations',
      'updateUserLanguage',
    ]),
    ...mapActions('profile', [
      'storeAvailablePrizeTypes',
      'storeAvailablePrizeTypesPerGame',
      'storeVisitorWinners',
    ]),
    isEligibleForPinChange() {
      return this.userDetails.hasPassword;
    },
    showAppropriateModal(actionCode) {
      let modal = '';
      switch (actionCode) {
      case 0: modal = ChangeUsername;
        break;
      case 1: modal = SetPin;
        break;
      default:
        break;
      }
      this.storeModalForSettings(modal);
    },
    userChangeStatus() {
      if (this.userDetails.subscribed) {
        if (this.subAndUnsubViaSMS) {
          if (this.reoptinAndOptoutConfig === 'OPTOUT_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
            this.storeModalForSettings(UnsubscribeSms);
          } else {
            this.storeModalForSettings(Unsubscribe);
          }
        } else {
          this.storeModalForSettings(Unsubscribe);
        }
      } else {
        // eslint-disable-next-line
        if (this.subAndUnsubViaSMS) {
          if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
            this.storeModalForSettings(ResubscribeQuestionViaSms);
          } else {
            this.storeModalForSettings(ResubscribeRequestSettings);
          }
        } else {
          this.storeModalForSettings(ResubscribeRequestSettings);
        }
      }
      modals.showHideModal(this);
    },
    getUserStatusMethod() {
      if (!this.userDetails.subscribed) {
        this.userStatus = this.getTranslations.home_settings_resubscribe;
      } else {
        this.userStatus = this.getTranslations.home_settings_unsubscribe;
      }
    },
    updateAndStoreNewLanguageAndLocale(locale, localeIndex) {
      this.updateActiveLocale(localeIndex);
      localStorage.setItem('locale', locale);
      this.setLocale({ currentLocale: locale });
      this.updateUserLanguage().then(() => {
        this.getLocaleAndTranslations().then(() => {
          this.storeAvailablePrizeTypes(this.getLocale).then(() => {
            this.storeAvailablePrizeTypesPerGame(this.getLocale);
          });
          this.storeVisitorWinners(this.getLocale);
        });
      });
    },
  },
  computed: {
    ...mapState('common', [
      'hideLangSelection',
      'hideChangePassword',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
      'soundsOn',
      'userDetails',
      'modalForSettings',
    ]),
    ...mapState('i18n', [
      'settingsPageLocales',
      'localesMappedWithIndices',
    ]),
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/ProfileEdit.vue